var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34002 12.0011C2.3392 11.6224 2.4459 11.2513 2.64771 10.9309C2.84952 10.6105 3.13814 10.3539 3.48002 10.1911L18.13 3.25108C18.3981 3.10489 18.6952 3.01954 19 3.00108C19.3336 3.00178 19.6617 3.0859 19.9545 3.24579C20.2473 3.40569 20.4954 3.63627 20.6763 3.91655C20.8572 4.19683 20.9651 4.51791 20.9902 4.85055C21.0153 5.18319 20.9568 5.51682 20.82 5.82108L18.54 11.0011L13 11.0011C12.7348 11.0011 12.4804 11.1064 12.2929 11.294C12.1054 11.4815 12 11.7359 12 12.0011C12 12.2663 12.1054 12.5207 12.2929 12.7082C12.4804 12.8957 12.7348 13.0011 13 13.0011L18.54 13.0011L20.82 18.1311C20.9852 18.5039 21.0325 18.9183 20.9556 19.3187C20.8787 19.7191 20.6812 20.0865 20.3896 20.3715C20.0981 20.6566 19.7263 20.8457 19.3243 20.9135C18.9222 20.9814 18.509 20.9247 18.14 20.7511L3.49002 13.8111C3.14627 13.6497 2.85558 13.3938 2.65193 13.0732C2.44828 12.7527 2.34009 12.3808 2.34002 12.0011Z",
    fill: "#00CEBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperSend);
export default __webpack_public_path__ + "static/media/paperSend.1cfc0ecea225ab462b04ade243fd5743.svg";
export { ForwardRef as ReactComponent };